import React from 'react';
import { countries } from '../../config/supported_areas';
import SelectInput from './SelectInput';

const FSCountry = ({ options, ...props }) => {
	return <SelectInput options={countries} {...props} />;
};

export default FSCountry;